module.exports = __webpack_public_path__ + "img/aleahia-hand.0a6b8aa7.png";